import $ from 'jquery';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import ReactDOM from 'react-dom';
import _ from 'underscore';

import {isValidDate} from 'util/DateUtil';
import {InputChangeEvent} from 'util/Types';

import {LegacyDateAndDatetimeInputProps, TextInputType} from './InputConstants';
import TextInput from './TextInput';

export const MOMENT_DATE_FORMAT = 'YYYY-MM-DD';
export const JQUERY_DATE_FORMAT = 'yy-mm-dd';

/**
 * Legacy, refrain from using this if possible as it will be soon deprecated. Use DatetimePicker instead.
 */
class LegacyDateInput extends React.Component<LegacyDateAndDatetimeInputProps> {
  static propTypes = {
    autoFocus: PropTypes.bool.isRequired,
    min: PropTypes.string,
    max: PropTypes.string,
    onKeyDown: PropTypes.func,
    placeholder: PropTypes.string.isRequired,
    value: PropTypes.string,
    onChange: PropTypes.func,
  };

  static defaultProps = {
    autoFocus: false,
    hasButton: false,
  };

  inputRef = React.createRef<TextInput>();

  componentDidMount(): void {
    this._datepicker({onSelect: this.props.onChange, dateFormat: JQUERY_DATE_FORMAT});
  }

  UNSAFE_componentWillReceiveProps(nextProps: LegacyDateAndDatetimeInputProps): void {
    const options: {
      minDate?: Date | null;
      maxDate?: Date | null;
    } = {};
    if (this.props.min !== nextProps.min) {
      options.minDate = nextProps.min ? moment(nextProps.min).toDate() : null;
    }
    if (this.props.max !== nextProps.max) {
      options.maxDate = nextProps.max ? moment(nextProps.max).toDate() : null;
    }
    if (!_.isEmpty(options)) {
      this._datepicker('option', options);
    }
  }

  componentDidUpdate(prevProps: LegacyDateAndDatetimeInputProps): void {
    if (this.props.value !== prevProps.value && isValidDate({textValue: this.props.value})) {
      this._datepicker('setDate', this.props.value);
    }
  }

  componentWillUnmount(): void {
    this._datepicker('destroy');
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _datepicker(...args: any): Element {
    // @ts-expect-error
    return $(ReactDOM.findDOMNode(this.inputRef.current)).datepicker(...args);
  }

  _clickHandler(): void {
    this._datepicker('show');
  }

  _setValue(e: InputChangeEvent): void {
    if (this.props.onChange) {
      this.props.onChange(e.target.value);
    }
  }

  _hasError(): boolean {
    return !isValidDate({
      textValue: this.props.value,
      min: this.props.min,
      max: this.props.max,
    });
  }

  render(): JSX.Element {
    return (
      <TextInput
        autoFocus={this.props.autoFocus}
        className={this.props.className}
        ref={this.inputRef}
        hasButton={this.props.hasButton}
        hasError={this._hasError()}
        value={this.props.value ? this.props.value : ''}
        onChange={(e: InputChangeEvent) => {
          this._setValue(e);
        }}
        onClick={() => {
          this._clickHandler();
        }}
        onKeyDown={this.props.onKeyDown}
        placeholder={this.props.placeholder}
        size={this.props.size}
        type={TextInputType.TEXT}
      />
    );
  }
}

export default LegacyDateInput;
